export default "__VITE_ASSET__CS2EYQi2__"